.circular-progress-bar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8rem;
  width: 8rem;
  font-size: 1.4rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
    z-index: -1;

    /* --progress-percent is set inline from the `progress` prop. */
    background: conic-gradient(
      var(--color-primary) var(--progress-percent),
      0,
      hsl(233 34% 92%) calc(100% - var(--progress-percent))
    );

    mask-image: radial-gradient(transparent 63%, black calc(63% + 0.5px));
  }

  cursor: pointer;

  &[data-controls='false'] {
    & .action {
      display: none;
    }

    &:hover {
      & .action {
        display: block;
      }

      & .progress {
        display: none;
      }
    }
  }
}
